import { gql } from "@apollo/client";

import { ORDER_FIELDS, OrderListingResponseType } from "./getOrderListingForCentral";

/**
 * 历史包裹查询（已归档订单，数据源 order_listing_history 索引）。
 *
 * 字段片段与 getOrderListingForCentral 共用 ORDER_FIELDS，返回结构完全一致——
 * 历史页「仿照包裹查询页」，列定义与详情弹窗都能直接复用。
 *
 * 注意：异常状态（exceptionStatus）来自 exception_order 表，历史链路不读该表，
 * 该字段恒为空；异常信息相关筛选条件传给后端也会被忽略。
 */
export const GET_ORDER_LISTING_HISTORY = gql`
    query OrderHistoryQuery($filters: OrderFiltersTypeInput,
                            $pageRequest: PageRequestTypeInput) {
        getOrderListingHistory(filters: $filters, pageRequest: $pageRequest) {
            content {
                ${ORDER_FIELDS}
                recipientAddress {
                    id
                    fullName
                    countryCode
                    phoneNumber
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    company
                    instructions
                }
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export interface HistoryOrderListResponse {
    getOrderListingHistory: OrderListingResponseType;
}
